import { Brand, Product } from './types';
import { MARKETPLACE_BG_COLORS } from '../../theme/brandColors';

export const PRODUCTS: Product[] = [
  {
    id: 1,
    name: 'Smart LED Bulb (Pack of 4)',
    category: 'Smart Home',
    brand: 'xiaomi',
    description: 'WiFi-enabled RGB smart bulbs, voice assistant compatible.',
    fullDescription:
      'WiFi-enabled RGB smart bulbs compatible with Alexa, Google Home, and Siri. 9W, 800 lm, 16 million colors, E27 fitting. App-controlled scheduling and scenes. Retail-boxed packs of 4 with setup guide.',
    priceQI: 2800,
    minQty: 50,
    stepQty: 10,
    emoji: '💡',
    bg: MARKETPLACE_BG_COLORS[0],
    origin: 'China',
    packaging: 'Retail box, 4 bulbs/pack',
    shelfLife: '36 months',
    certifications: ['CE', 'RoHS', 'FCC'],
  },
  {
    id: 2,
    name: 'Wireless Earbuds Pro X',
    category: 'Audio',
    brand: 'sony',
    description: 'ANC wireless earbuds, BT 5.3, 40hr total battery life.',
    fullDescription:
      'Active noise-cancellation earbuds with Bluetooth 5.3 and dual-mic transparency mode. 10hr playtime + 30hr charging case. IPX5 water-resistant. Retail-ready packaging with USB-C cable and 3 ear tip sizes.',
    priceQI: 8900,
    minQty: 20,
    stepQty: 5,
    emoji: '🎧',
    bg: MARKETPLACE_BG_COLORS[1],
    origin: 'China',
    packaging: 'Premium retail box',
    shelfLife: 'N/A',
    certifications: ['CE', 'FCC', 'UKCA'],
  },
  {
    id: 3,
    name: 'Smart LED Strip 5m',
    category: 'Smart Home',
    brand: 'xiaomi',
    description: 'RGB WiFi LED strips, app-controlled with music sync mode.',
    fullDescription:
      'Flexible 5m RGB LED strip with WiFi + IR control. 12V, 300 LEDs per strip, 16M colors, music sync via microphone. Compatible with Alexa and Google. Includes power adaptor and adhesive backing. Retail boxed.',
    priceQI: 2200,
    minQty: 30,
    stepQty: 10,
    emoji: '🌈',
    bg: MARKETPLACE_BG_COLORS[2],
    origin: 'China',
    packaging: 'Retail box with adaptor',
    shelfLife: '24 months',
    certifications: ['CE', 'RoHS'],
  },
  {
    id: 4,
    name: 'USB-C Fast Charger 65W',
    category: 'Accessories',
    brand: 'anker',
    description: 'GaN 65W 3-port fast charger, compatible with all USB-C devices.',
    fullDescription:
      'GaN-based 65W charger with 2× USB-C (PD 65W/18W) and 1× USB-A (QC 3.0). Charges laptops, tablets, and phones simultaneously. 40% smaller than standard chargers. Includes travel pouch. Retail boxed.',
    priceQI: 3400,
    minQty: 40,
    stepQty: 10,
    emoji: '🔌',
    bg: MARKETPLACE_BG_COLORS[3],
    origin: 'China',
    packaging: 'Retail box with cable',
    shelfLife: '36 months',
    certifications: ['CE', 'FCC', 'RoHS'],
  },
  {
    id: 5,
    name: 'Portable Power Bank 20000mAh',
    category: 'Accessories',
    brand: 'anker',
    description: '20000mAh power bank with 22.5W fast charge, dual output.',
    fullDescription:
      '20000mAh lithium-polymer power bank with 22.5W fast charging output (USB-C PD + USB-A). Digital battery display. 500+ recharge cycles. Airline-safe. Retail-packaged with USB-C cable and drawstring pouch.',
    priceQI: 5600,
    minQty: 25,
    stepQty: 5,
    emoji: '🔋',
    bg: MARKETPLACE_BG_COLORS[4],
    origin: 'China',
    packaging: 'Retail box',
    shelfLife: '24 months',
    certifications: ['CE', 'UN38.3', 'MSDS'],
  },
  {
    id: 6,
    name: 'Robot Vacuum Cleaner',
    category: 'Home Appliances',
    brand: 'dyson',
    description: 'Auto-mapping robot vacuum with 2700Pa suction, WiFi control.',
    fullDescription:
      'LiDAR auto-mapping robot vacuum with 2700Pa suction, 150-min runtime, and auto-recharge. WiFi + app control with room zoning. Works on tile, hardwood, and low-pile carpet. Retail-packaged with charging dock.',
    priceQI: 18500,
    minQty: 10,
    stepQty: 5,
    emoji: '🤖',
    bg: MARKETPLACE_BG_COLORS[5],
    origin: 'China',
    packaging: 'Retail master carton, 1 unit/box',
    shelfLife: 'N/A',
    certifications: ['CE', 'FCC', 'RoHS'],
  },
  {
    id: 7,
    name: 'Air Purifier HEPA H13',
    category: 'Home Appliances',
    brand: 'lg',
    description: 'True HEPA H13 air purifier, 360° filtration, 45m² coverage.',
    fullDescription:
      'True HEPA H13 + activated carbon 3-stage filter. Covers up to 45m² in 30 min. CADR 250m³/h. Auto-mode with air quality sensor, sleep mode, child lock. 360° air intake. Retail boxed with spare filter.',
    priceQI: 12400,
    minQty: 10,
    stepQty: 5,
    emoji: '🌬️',
    bg: MARKETPLACE_BG_COLORS[6],
    origin: 'South Korea',
    packaging: 'Retail box, 1 unit',
    shelfLife: 'N/A',
    certifications: ['CE', 'ENERGY STAR', 'RoHS'],
  },
  {
    id: 8,
    name: 'Mechanical Gaming Keyboard',
    category: 'Computing',
    brand: 'logitech',
    description: 'TKL mechanical keyboard, RGB per-key, hot-swap switches.',
    fullDescription:
      'Tenkeyless (TKL) mechanical keyboard with hot-swappable blue/red switch options. Per-key RGB backlight with 18 effects. N-key rollover, aluminum top plate, detachable USB-C cable. Retail boxed with switch puller and extras.',
    priceQI: 7200,
    minQty: 20,
    stepQty: 5,
    emoji: '⌨️',
    bg: MARKETPLACE_BG_COLORS[7],
    origin: 'China',
    packaging: 'Retail box',
    shelfLife: 'N/A',
    certifications: ['CE', 'FCC'],
  },
  {
    id: 9,
    name: 'Dash Cam 4K Dual Lens',
    category: 'Automotive',
    brand: 'bosch',
    description: '4K front + 1080p rear dash cam, GPS, parking mode, WiFi.',
    fullDescription:
      '4K front camera + 1080P rear camera with GPS logging, WiFi app transfer, and 24hr parking mode with voltage protection. 170° wide angle, night vision, loop recording. Includes 32GB card and hardwire kit.',
    priceQI: 9800,
    minQty: 15,
    stepQty: 5,
    emoji: '📷',
    bg: MARKETPLACE_BG_COLORS[8],
    origin: 'China',
    packaging: 'Retail box with accessories',
    shelfLife: 'N/A',
    certifications: ['CE', 'FCC', 'RoHS'],
  },
];

export const CATEGORIES = [
  'All',
  'Smart Home',
  'Audio',
  'Accessories',
  'Home Appliances',
  'Computing',
  'Automotive',
];

export const BRANDS: Brand[] = [
  { id: 'xiaomi', name: 'Xiaomi', initial: 'Xi' },
  { id: 'sony', name: 'Sony', initial: 'So' },
  { id: 'anker', name: 'Anker', initial: 'An' },
  { id: 'dyson', name: 'Dyson', initial: 'Dy' },
  { id: 'lg', name: 'LG', initial: 'LG' },
  { id: 'logitech', name: 'Logitech', initial: 'Lg' },
  { id: 'bosch', name: 'Bosch', initial: 'Bo' },
];
